import React, { useEffect, useState } from "react";
import MaintenancePage from "./index";
import { fetchMaintenanceStatus, onMaintenance, pollDelayMs } from "@/services/maintenance";

const reloadPage = () => window.location.reload();

const MaintenanceGate = ({
    children,
    forced = false,
    checkStatus = fetchMaintenanceStatus,
    onRecovered = reloadPage,
}) => {
    const [maintenance, setMaintenance] = useState(forced ? {} : null);

    useEffect(() => {
        if (forced) {
            return undefined;
        }
        let active = true;
        checkStatus()
            .then((status) => active && status && setMaintenance(status))
            .catch(() => {});
        const unsubscribe = onMaintenance(setMaintenance);
        return () => {
            active = false;
            unsubscribe();
        };
    }, [forced, checkStatus]);

    const isDown = Boolean(maintenance);
    const firstRetryAfter = maintenance && maintenance.retryAfter;

    useEffect(() => {
        if (forced || !isDown) {
            return undefined;
        }
        let active = true;
        let timer;
        const pollAfter = (retryAfter) => {
            timer = setTimeout(() => {
                checkStatus()
                    .then((status) => {
                        if (!active) return;
                        if (!status) {
                            onRecovered();
                            return;
                        }
                        setMaintenance(status);
                        pollAfter(status.retryAfter);
                    })
                    .catch(() => active && pollAfter(retryAfter));
            }, pollDelayMs(retryAfter));
        };
        pollAfter(firstRetryAfter);
        return () => {
            active = false;
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forced, isDown, checkStatus, onRecovered]);

    return maintenance ? <MaintenancePage message={maintenance.message}/> : children;
};

export default MaintenanceGate;
